import { useQuery } from 'react-query';
import { useTokenizedApi } from '../useTokenizedApi';
import { usePersonalProfile } from '../entities/usePersonalProfile';
import { usePrimaryLockbox } from '../treasury/usePrimaryLockbox';
import { useActivityEvent } from '../activity/useActivityEvent';

export function useNewRequestAsActivityEvent({
  profileId,
  lockboxId,
  recipient,
  instrument,
  memo,
  isConfirming,
}) {
  const tokenizedApi = useTokenizedApi();

  const personalProfile = usePersonalProfile();
  profileId = profileId || personalProfile?.id;

  const primaryLockbox = usePrimaryLockbox(profileId);
  lockboxId = lockboxId || primaryLockbox?.id;

  const lockboxes = useQuery(tokenizedApi.treasury.lockboxesQuery())?.data;

  const activityEvent =
    tokenizedApi.transfers.makeActivityEventForUnconfirmedRequest({
      profileId,
      lockboxId,
      recipient,
      instrument,
      memo,
      isConfirming,
      lockboxes,
      ownHandle: personalProfile?.handle,
    });

  return useActivityEvent(activityEvent);
}
